import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Phone, Copy, Check } from 'lucide-react';
export function DomainCTA() {
  const [copied, setCopied] = useState(false);
  const phoneNumber = '305-877-9092';
  const handleCopy = () => {
    navigator.clipboard.writeText(phoneNumber);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <section className="py-32 px-6 relative overflow-hidden" data-id="element-7">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-magenta-500/5 rounded-full blur-3xl pointer-events-none" data-id="element-8" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-9">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-10">
          <h2 className="font-serif text-4xl md:text-6xl mb-8" data-id="element-11">
            Shape the future.
          </h2>
          <p className="text-xl text-zinc-400 mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-12">
            This concept is still in the thought process, and the domain{' '}
            <span className="text-zinc-200 font-medium" data-id="element-13">danceforfans.com</span>{' '}
            is available and for sale.
          </p>

          <div className="bg-zinc-900/80 backdrop-blur-sm border border-zinc-800 p-8 md:p-12 rounded-3xl max-w-xl mx-auto shadow-2xl" data-id="element-14">
            <p className="text-sm text-zinc-500 uppercase tracking-widest mb-6" data-id="element-15">
              Direct Contact
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8" data-id="element-16">
              <a href={`tel:+1${phoneNumber.replace(/-/g, '')}`} className="flex items-center gap-3 text-3xl md:text-4xl font-serif text-magenta-500 hover:text-magenta-400 transition-colors" data-id="element-17">
                <Phone className="w-8 h-8" data-id="element-18" />
                {phoneNumber}
              </a>

              <button onClick={handleCopy} className="p-3 bg-zinc-800 hover:bg-zinc-700 rounded-full transition-colors text-zinc-400 hover:text-zinc-200" aria-label="Copy phone number" data-id="element-19">
                {copied ? <Check className="w-5 h-5 text-green-500" data-id="element-20" /> : <Copy className="w-5 h-5" data-id="element-21" />}
              </button>
            </div>

            <p className="text-zinc-400" data-id="element-22">
              Ask for <span className="text-zinc-200 font-medium" data-id="element-23">Jose</span> to
              discuss acquiring this domain and concept.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}